import { A11yModule } from "@angular/cdk/a11y";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { SharedPipesModule } from "../pipes/shared-pipes.module";
import { TranslateModule } from '@ngx-translate/core';
import { ACheckboxComponent } from "./a-checkbox/a-checkbox.component";
import { ADatepickerComponent } from "./a-datepicker/a-datepicker.component";
import { AInputComponent } from "./a-input/a-input.component";
import { ARadioComponent } from "./a-radio/a-radio.component";
import { ASelectInputComponent } from "./a-select-input/a-select-input.component";
import { ASelectLocationComponent } from "./a-select-location/a-select-location.component";
import { ASelectMultipleComponent } from "./a-select-multiple/a-select-multiple.component";
import { ASelectComponent } from "./a-select/a-select.component";
import { ASwitcherComponent } from "./a-switcher/a-switcher.component";
import { ATextareaComponent } from "./a-textarea/a-textarea.component";
import { ButtonWithLoaderComponent } from "./btn-with-loader/btn-with-loader.component";
import { HardSkillsTreeComponent } from "./hard-skills-tree/hard-skills-tree.component";
import { NotifyPopupComponent } from "./notify-popup/notify-popup.component";
import { RoundProgressComponent } from "./round-progress/round-progress.component";
import { StepperComponent } from "./stepper/stepper.component";
import { StellarSoftComponent } from "./stellar-soft/stellar-soft.component";
import { StellarComponent } from "./stellar/stellar.component";
import { VideoPopupComponent } from "./video-popup/video-popup.component";
import { EmailEngagementHistoryComponent } from "./email-engagement-history/email-engagement-history.component";
import { VacancyTalentInfoComponent } from "./vacancy-talent-info/vacancy-talent-info.component";
import { MatchItemComponent } from "./match-item/match-item.component";
import { MatchDetailsComponent } from "./match-details/match-details.component";
import { MatchDetailsReportComponent } from "./match-details-report/match-details-report.component";
import { VacancyTalentDetailsComponent } from "./vacancy-talent-details/vacancy-talent-details.component";
import { SkillRangeSelectorComponent } from "./hard-skills-tree/skill-range-selector/skill-range-selector.component";
import { SkillsSearchInputComponent } from "./hard-skills-tree/skills-search-input/skills-search-input.component";
import { AvatarImageDirective } from "./avatar-image-directive/avatar-image.directive";
import { ConfirmHireListComponent } from "./confirm-hire-list/confirm-hire-list.component";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { SavingStatusDirective } from "./saving-status-directive/saving-status.directive";
import { LottieModule } from 'ngx-lottie';
import { LottieLoaderComponent } from "./lottie-loader/lottie-loader.component";
import { GoogleMapsModule } from "@angular/google-maps";
import { ATextEditorComponent } from "./a-texteditor/a-texteditor.component";
import { MainMenuComponent } from "./main-menu/main-menu.component";
import { RouterModule } from "@angular/router";
import { SharePopupComponent } from "./share-popup/share-popup.component";
import { ShareDirective } from "./share-directive/share-directive.directive";
import { ShareModule } from "ngx-sharebuttons";
import { VacancyConnectComponent } from "./vacancy-connect/vacancy-connect.component";
import { ResizeListenerDirective } from "./resize-listener-directive/resize-listener.directive";
import { WordWrapDirective } from "./word-wrap-directive/word-wrap.directive";
import { FilesManagerComponent } from "./files-manager/files-manager.component";
import { HintFrameComponent } from "./hint-frame/hint-frame.component";
import { MobileSwipeHintComponent } from "./mobile-swipe-hint/mobile-swipe-hint.component";
import { ASelectCompanyComponent } from "./a-select-company/a-select-company.component";
import { ASelectAutocompeteComponent } from "./a-select-autocomplete/a-select-autocomplete.component";
import { QuillModule } from "ngx-quill";
import { BadgesNotifyComponent } from "./badges-notify/badges-notify.component";
import { BadgesCountComponent } from "./badges-count/badges-count.component";
import { CVUploadDirective } from "./cv-upload-directive/cv-upload.directive";
import { CvConfirmationComponent } from "./cv-confirmation/cv-confirmation.component";
import { AddChangeAssessmentComponent } from './add-change-assessment/add-change-assessment.component';
import { HasclaimdirectiveDirective } from './hasclaim-directive/hasclaimdirective.directive';
import { AddonPurchaseModalComponent } from './addon-purchase-modal/addon-purchase-modal.component';
import { AddonQuantitySelectorModalComponent } from './addon-quantity-selector-modal/addon-quantity-selector-modal.component';
import { VacancyWarningPopupComponent } from './notify-warning-popup/vacancy-warning-popup.component';
import { MatchPriorityPopoverComponent } from './match-priority-popover/match-priority-popover.component';


export function playerFactory(): any {  
  return import('lottie-web');
}

const quillConfig = {
  modules: {
    clipboard: {
      matchVisual: false
    },
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'align': '' }, { 'align': 'center' }, { 'align': 'right' }],
      [{ 'direction': 'rtl' }],
      [{ 'header': [false, 3, 4, 5 ] }],
      ['clean']
    ]
  }
}

const components = [
  AInputComponent,
  ATextareaComponent,
  ASelectInputComponent,
  ASelectComponent,
  ASelectLocationComponent,
  ASelectMultipleComponent,
  ASelectCompanyComponent,
  ASelectAutocompeteComponent,
  ARadioComponent,
  ASwitcherComponent,
  ACheckboxComponent,
  ADatepickerComponent,
  ATextEditorComponent,
  ButtonWithLoaderComponent,
  StellarComponent,
  StellarSoftComponent,
  VideoPopupComponent,
  NotifyPopupComponent,
  StepperComponent,
  HardSkillsTreeComponent,
  RoundProgressComponent,
  EmailEngagementHistoryComponent,
  VacancyTalentInfoComponent,
  VacancyTalentDetailsComponent,
  MatchItemComponent,
  MatchDetailsComponent,
  MatchDetailsReportComponent,
  SkillRangeSelectorComponent,
  SkillsSearchInputComponent,
  ConfirmHireListComponent,
  LottieLoaderComponent,
  MainMenuComponent,
  SharePopupComponent,
  VacancyConnectComponent,
  FilesManagerComponent,
  HintFrameComponent,
  MobileSwipeHintComponent,
  BadgesNotifyComponent,
  BadgesCountComponent,
  ShareDirective,
  AvatarImageDirective,
  SavingStatusDirective,
  ResizeListenerDirective,
  WordWrapDirective,
  CVUploadDirective,
  CvConfirmationComponent,
  HasclaimdirectiveDirective,
  AddonPurchaseModalComponent,
  AddonQuantitySelectorModalComponent,
  VacancyWarningPopupComponent,
  MatchPriorityPopoverComponent
];

@NgModule({
  declarations: [ ...components, AddChangeAssessmentComponent ],
  imports: [
    A11yModule,
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    FormsModule,
    ShareModule,
    SharedPipesModule,
    InfiniteScrollModule,
    LottieModule.forRoot({ player: playerFactory }),
    GoogleMapsModule,
    NgxDaterangepickerMd.forRoot(),
    QuillModule.forRoot(quillConfig),
    TranslateModule
   ],
  exports: [ ...components, TranslateModule ]
})

export class SharedComponentsModule {};
